import SectionCard from "../../SectionCard";
import SectionRow from "../../SectionRow";
import InlineFormText from "components/lib-ui/inline-forms/InlineFormText";
import InlineFormSelect from "components/lib-ui/inline-forms/InlineFormSelect";
import { GlobalAppDataStorageService } from "infra/storage";
import GeneralUtilityService from "services/GeneralUtilityService";

export const Compensation = ({ candidate }) => {
    const {
        availability,
        grossAnnualSalary,
        netMontlySalary,
        noticePeriod,
        compensationPreferences,
        currency 
    } = candidate;


    const availabilityToMonth =
        GeneralUtilityService.convertDateToMonthInput(availability);
    const compensationPreferencesOptions =
        GlobalAppDataStorageService.getCompensationPreferences();
    const salaryCurrenciesOptions =
        GlobalAppDataStorageService.getSalaryCurrencies();

    return (
        <>
            <SectionCard title="Compensation Preferences">
                <SectionRow title="Currency">
                    <InlineFormSelect
                        multiple={false}
                        fieldName="currencyId"
                        options={salaryCurrenciesOptions || []}
                        selected={ currency }
                        isCurrency={true}
                    />
                </SectionRow>
                <SectionRow
                    title='Net monthly salary'
                    fieldKey="net-salary"
                >
                    <InlineFormText
                        fieldName="original_min_monthly_net_salary"
                        before={currency?.symbol || '€'}
                        type="number"
                        defaultValue={netMontlySalary}
                        isCurrency={true}
                    />
                </SectionRow>
                <SectionRow
                    title="Gross annual salary"
                    fieldKey="gross-salary"
                >
                    <InlineFormText
                        fieldName="original_min_annual_gross_salary"
                        before={currency?.symbol || '€'}
                        type="number"
                        defaultValue={grossAnnualSalary}
                        isCurrency={true}
                    />
                </SectionRow>
                <SectionRow title="Payment method">
                    <InlineFormSelect
                        multiple
                        fieldName="compensation_preferences"
                        options={compensationPreferencesOptions || []}
                        selected={compensationPreferences}
                    />
                </SectionRow>
                <SectionRow title="Notice Period (weeks)" fieldKey="notice-period">    
                    <InlineFormText
                        fieldName="notice_period"
                        type="number"
                        defaultValue={noticePeriod}
                    />
                </SectionRow>
                <SectionRow title="Availability">
                    <InlineFormText
                        fieldName="availability"
                        type="month"
                        defaultValue={availabilityToMonth}
                    />
                </SectionRow>
            </SectionCard>
        </>
    );
};

export default Compensation;
